export class CompetitorCount {
  total?: number;
}
